import { searchContent } from '@plone/volto/actions/search/search';

export const NEWS_SUBREQUEST = 'asaj-classic-news';
export const EVENTS_SUBREQUEST = 'asaj-classic-events';

export const classicHomeAsyncPropExtender = {
  path: '/',
  exact: true,
  extend: (dispatchActions) => {
    if (dispatchActions.filter((a) => a.key === NEWS_SUBREQUEST).length === 0) {
      dispatchActions.push({
        key: NEWS_SUBREQUEST,
        promise: ({ store: { dispatch } }) =>
          dispatch(
            searchContent(
              '',
              {
                portal_type: 'News Item',
                sort_on: 'effective',
                sort_order: 'reverse',
                b_size: 5,
                metadata_fields: [
                  'effective',
                  'description',
                  'image_field',
                  'image_scales',
                ],
              },
              NEWS_SUBREQUEST,
            ),
          ),
      });
    }
    if (
      dispatchActions.filter((a) => a.key === EVENTS_SUBREQUEST).length === 0
    ) {
      dispatchActions.push({
        key: EVENTS_SUBREQUEST,
        promise: ({ store: { dispatch } }) =>
          dispatch(
            searchContent(
              '',
              {
                portal_type: 'Event',
                'start.query': new Date().toISOString(),
                'start.range': 'min',
                sort_on: 'start',
                b_size: 5,
                metadata_fields: ['start'],
              },
              EVENTS_SUBREQUEST,
            ),
          ),
      });
    }
    return dispatchActions;
  },
};
